import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
var ɵ0 = { page: 'login' }, ɵ1 = { page: 'registration' };
var routes = [
    { path: 'belepes', component: LoginComponent, data: ɵ0 },
    { path: 'regisztracio', component: RegistrationComponent, data: ɵ1 },
];
var AuthRoutingModule = /** @class */ (function () {
    function AuthRoutingModule() {
    }
    return AuthRoutingModule;
}());
export { AuthRoutingModule };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/auth-routing.module.ts.pre-build-optimizer.js